import Immutable from 'immutable';

export interface RawPermissions {
  managePeople: boolean;
  editDescription: boolean;
  addPhoto: boolean;
  addMarkup: boolean;
  editLocation: boolean;
  editDueDate: boolean;
  editAssignee: boolean;
  manageCustomDisciplines: boolean;
  setStatusOpen: boolean;
  setStatusAccepted: boolean;
  setStatusReview: boolean;
  setStatusOutOfScope: boolean;
  setStatusClosed: boolean;
  addComments: boolean;
  generateReport: boolean;
  createPunch: boolean;
  deletePunch: boolean;
  deletePhoto: boolean;
  removeUser: boolean;
  publishDrawings: boolean;
  createRfi: boolean;
  createSubmittal: boolean;
  adminRfi: boolean;
  adminSubmittal: boolean;
  viewUsers: boolean;
  activeProject: boolean;
  createMapLayer: boolean;
  // [key: string]: boolean;
}

const defaultValues: RawPermissions = {
  managePeople: false,
  editDescription: false,
  addPhoto: false,
  addMarkup: false,
  editLocation: false,
  editDueDate: false,
  editAssignee: false,
  manageCustomDisciplines: false,
  setStatusOpen: false,
  setStatusAccepted: false,
  setStatusReview: false,
  setStatusOutOfScope: false,
  setStatusClosed: false,
  addComments: false,
  generateReport: false,
  createPunch: false,
  deletePunch: false,
  deletePhoto: false,
  removeUser: false,
  publishDrawings: false,
  createRfi: false,
  createSubmittal: false,
  adminRfi: false,
  adminSubmittal: false,
  viewUsers: false,
  activeProject: false,
  createMapLayer: false,
};

const basicOrUnpaidTierValues: RawPermissions = {
  managePeople: false,
  editDescription: false,
  addPhoto: true,
  addMarkup: false,
  editLocation: false,
  editDueDate: false,
  editAssignee: false,
  manageCustomDisciplines: false,
  setStatusOpen: false,
  setStatusAccepted: false,
  setStatusReview: true,
  setStatusOutOfScope: true,
  setStatusClosed: false,
  addComments: true,
  generateReport: false,
  createPunch: false,
  deletePunch: false,
  deletePhoto: false,
  removeUser: false,
  publishDrawings: false,
  createRfi: false,
  createSubmittal: false,
  adminRfi: false,
  adminSubmittal: false,
  viewUsers: false,
  activeProject: false,
  createMapLayer: false,
};

export const PermissionsFactory = Immutable.Record(
  defaultValues,
  'Permissions'
);

export class Permissions extends PermissionsFactory {
  static deserialize(
    rawPermissions: RawPermissions,
    isBasicOrUnpaidTier = false
  ): Permissions {
    if (isBasicOrUnpaidTier) {
      return new Permissions({ ...basicOrUnpaidTierValues });
    }

    return new Permissions({
      ...rawPermissions,
    });
  }

  serialize(): RawPermissions {
    return this.toObject();
  }
}
